'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Security = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 4L7 8.92587V21.6619C7 31.1872 20 36 20 36C20 36 33 31.1872 33 21.6619V8.92587L20 4Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.8329 19.4866C22.1143 19.2511 22.3407 18.9591 22.4967 18.6304C22.6526 18.3017 22.7344 17.944 22.7366 17.5816C22.7366 16.1557 21.5118 15 20 15C18.4883 15 17.2634 16.1557 17.2634 17.5816C17.2634 18.3395 17.6159 19.0142 18.1671 19.4866L17 24H23L21.8329 19.4866Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = Security;
